<template>
  <el-container v-loading="cameraLoading">
    <main class="tab__container">
      <h2 class="page__title">
        Камера:
        <span style="color: black">{{ camera.nimble_id }}</span>
        <camera-status v-if="camera.state" style="margin-left: 10px; bottom: 2px;" :status="camera.state" />
        <camera-agent-status v-if="agent_status" style="float: right" :status="agent_status" />
        <camera-stream-status v-if="camera.camera_status" style="float: right" :status="camera.camera_status" />
        <camera-platform style="float: right" :id-media-core="camera.server_id_media_core" />
        <span v-if="camera.is_deleted === 1" style="float: right">Камера удалена</span>
      </h2>
      <el-tabs @tab-click="onTabClick">
        <el-tab-pane v-for="(tab, i) in components" :label="tab.name" :key="i">
          <component v-bind="tab.props" :is="tab.component" />
        </el-tab-pane>
      </el-tabs>
    </main>
  </el-container>
</template>
<script>
import CameraEdit from "@/components/Cameras/components/Camera/tabs/CameraEdit";
import CameraAccessSettings from "@/components/Cameras/components/Camera/tabs/CameraAccessSettings";
import { mapActions, mapMutations, mapState } from "vuex";
import { checkPermission } from "@/core/helpers/permissions";
import CameraLogs from "@/components/Cameras/components/Camera/tabs/CameraLogs";
import CameraSharingHistory from "@/components/Cameras/components/Camera/tabs/CameraSharingHistory";
import CameraMonitoring from "@/components/Cameras/components/Camera/tabs/CameraMonitoring";
import CameraStatus from "@/components/Cameras/components/Camera/features/CameraStatus";
import CameraConfig from "@/components/Cameras/components/Camera/tabs/CameraConfig";
import CameraAgentStatus from '@/components/Cameras/components/Camera/features/CameraAgentStatus';
import CameraStreamStatus from '@/components/Cameras/components/Camera/features/CameraStreamStatus';
import CameraPlatform from '@/components/Cameras/components/Camera/features/CameraPlatform';

export default {
  name: "Camera",
  components: { CameraStatus, CameraConfig, CameraAgentStatus, CameraStreamStatus, CameraPlatform, CameraMonitoring },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      components: [],
      cameraLoading: true,
    };
  },
  computed: {
    ...mapState("cameras", ["camera", "agent_status"]),
  },
  watch: {
    camera: {
      immediate: true,
      handler() {
        this.getTabs()
      },
    },
  },
  created() {
    this.getCamera(this.id)
      .then(data => {
        if (data.serial_number != null && data.is_deleted !== 1) this.getCameraAgentStatus(this.camera.id_camera)
      })
      .finally(() => this.cameraLoading = false)
    this.setCameraAgentStatus("")
  },
  methods: {
    onTabClick(tab) {
      if (tab.label === "История шаринга") {
        this.$root.$emit("camera-sharing-history-tab-activated");
      }
    },
    getTabs() {
      const tabs = [
        {
          name: "Настройки камеры",
          component: CameraEdit,
          permission: "cameras:read",
          props: {},
        },
        {
          name: "Настройки доступа",
          component: CameraAccessSettings,
          permission: "cameras_recipients:read",
          hideIfDeleted: true,
          props: {
            cameraId: this.id,
          },
        },
        {
          name: "История шаринга",
          component: CameraSharingHistory,
          permission: "cameras_recipients:read",
          props: {
            id: this.id,
          },
        },
        {
          name: "Логи",
          component: CameraLogs,
          permission: "cameras:read",
          props: {
            id: this.id,
          },
        },
        {
          name: "Конфигурация",
          component: CameraConfig,
          permission: "cameras_config:read",
          props: {
            id: this.id,
          },
        },
        {
          name: "Мониторинг",
          component: CameraMonitoring,
          permission: "cameras:read",
          props: {
            id: this.id,
          }
        }
      ]

      this.components = tabs.filter((tab) => {
          if (!checkPermission(tab.permission)) return false
          if (tab.hideIfDeleted && this.camera.is_deleted === 1) return false
          return true
        }
      )
    },
    ...mapActions("cameras", {
      getCamera: "GET_CAMERA",
      getCameraAgentStatus: "GET_CAMERA_AGENT_STATUS"
    }),
    ...mapMutations("cameras", {
      setCameraAgentStatus: "SET_CAMERA_AGENT_STATUS",
      setCameraPublishUrls: "SET_CAMERA_PUBLISH_URLS"
    })
  },
};
</script>
